import { LANDING_PAGE_URL } from "./urlConstants";

export const POST_AUTH_PATH_STORAGE_KEY = "current-pathname";

export const consumePostAuthPath = (): string => {
  const postAuthPath =
    sessionStorage.getItem(POST_AUTH_PATH_STORAGE_KEY) || LANDING_PAGE_URL;
  sessionStorage.removeItem(POST_AUTH_PATH_STORAGE_KEY);
  return postAuthPath;
};
